<template>
	<div id="org_edit">
		<van-cell-group style="width: 95%;margin: 10px 2.5%;">
			<van-radio-group>
				<span class="van-radio-lable" style="margin-left: 2%;"><span style="color: red;">*</span>组织封面</span>
				<van-uploader :after-read="onRead">
					<van-button type="info">上传封面</van-button>
				</van-uploader>
				<img :src="Data.organizationSeal|addPath" style="margin: 2px 10%;width: auto;height: 40px;" :style="{display:(Data.organizationSeal==''?'none':'')}" />
			</van-radio-group>
			<van-field style="height: 0px;padding: 1px;" />
			<van-field v-model="Data.regulatorArea" required clearable label="机构地区" placeholder="选择地区" @focus="select" />
			<van-field v-model="Data.address" required clearable label="详细地址" placeholder="请输入详细地址" />
			<van-field v-model="Data.leaderCellphone" required clearable label="手机号码" placeholder="请输入手机号码" />
			<van-field v-model="Data.linkman" required clearable label="负责人" placeholder="负责人" />
			<van-field v-model="Data.leaderEmail" clearable label="邮箱地址" placeholder="请输入邮箱地址" />
			<van-radio-group>
				<span class="van-radio-lable" style="margin-left: 2%;"><span style="color: red;">*</span>服务类别</span>
				<select v-model="Data.serviceType" style="background: white;border: 0px;pause: 20px; box-shadow: 12;">
					<option v-for="(item,index) in columns">{{item}}</option>
				</select>
			</van-radio-group>
			<van-field style="height: 0px;padding: 1px;" />
			<span class="van-radio-lable">组织简介</span>
			<div style="height: 300px;width: 95;margin: 2.5%;" id="photo2">
				<van-uploader :after-read="onRead2" style="display: none;">
					<van-cell :icon="photo2" title="" />
				</van-uploader>
				<quill-editor style="height: 250px;" v-model="orgIntroduction" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
				</quill-editor>
			</div>
		</van-cell-group>
		<van-popup v-model="show" position="bottom" style="top:50%">
			<van-area :area-list="areaList" @confirm='confirm' @cancel='cancel' :visible-item-count="7" />
		</van-popup>
		<van-button @click="ajax" size="large" style="width: 95%;margin: 10px 2.5%;background-color: orangered;border-radius: 5px;color: white;">确认修改</van-button>
	</div>
</template>

<script>
	import { Field, Cell, CellGroup, Button, Notify, RadioGroup, Radio, Checkbox, CheckboxGroup, Area, Popup, Toast, Uploader } from 'vant';
	import global from '@/api/global';
	import axios from 'axios';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	import { quillEditor } from 'vue-quill-editor';
	import { quillRedefine } from 'vue-quill-editor-upload';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	Vue.use(VueCookies);
	export default {
		components: {
			[Field.name]: Field,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Button.name]: Button,
			[Notify.name]: Notify,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
			[Popup.name]: Popup,
			[Area.name]: Area,
			[Toast.name]: Toast,
			[Uploader.name]: Uploader
		},
		computed: {
			UploadPath: function() {
				return global.baseURL + 'base/uploadfile';
			},
			orgIntroduction: {
				get:function(){
					return this.Data.orgIntroduction;
				},
				set:function(value){
					this.Data.orgIntroduction = htmlspecialchars_decode(value);
				}
			}
		},
		filters: {
			addPath(path) {
				return global.resoursePhoto + '/' + path;
			}
		},
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', ], // toggled buttons
								['blockquote'],
								['image'],
								[{
									'color': []
								}] // 字体大小
							],
							handlers: {
								'image': function(value) {
									if(value) {
										document.querySelector('#photo2 .van-uploader__input').click();
									}
								}
							}
						}
					}
				},
				photo2: "", //富文本图片
				areaList,
				show: false,
				dialogImageUrl: '',
				dialogVisible: false,
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				Data: {
					/*orgName: "", //组织名称
					organizationCode: "", //组织代码
					volunteerCorps: "", //地区代码
					leaderCellphone: "", //负责人号码
					leaderEmail: "", //电子邮箱
					address: "", //详细地址
					reason: "", //申请理由
					orgRecord: "法人组织", //登记状态
					linkman: "", //负责人姓名
					area: "", //地区名称
					oid: Number, //主管部门
					serviceType: "", //服务类型
					orgIntroduction:""//组织介绍*/
				},
				columns: []
			}
		},
		created() {
			//this.getOid();
			this.getType();
		},
		methods: {
			checkForm() {
				if(this.Data.volunteerCorps==""){
					Toast("机构地区不能为空");
					return false;
				}
				if(this.Data.address==""){
					Toast("详细地址不能为空");
					return false;
				}
				if(!this.isPoneAvailable(this.Data.leaderCellphone)) {
					return false;
				}
				if(this.Data.linkman==""){
					Toast("负责人姓名不能为空");
					return false;
				}
				if(this.Data.serviceType==""){
					Toast("服务类别不能为空");
					return false;
				}
				return true;
			},
			//手机验证
			isPoneAvailable(str) {
				var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
				if(!myreg.test(str)) {
					Toast("手机格式错误");
					return false;
				} else {
					return true;
				}
			},
			//封面图片
			onRead(file) {
				let param = new FormData(); //创建form对象     
				param.append('base64Data', file.content); //通过append向form对象添加数据
				param.append('height', '260'); //添加form表单中其他数据
				param.append('width', '260'); //添加form表单中其他数据
				//console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
				var image_ = "";
				axios({
					method: "POST",
					url: global.baseURL + 'base/uploadImgCommon',
					data: param,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((resp) => {
					this.Data.organizationSeal = resp.data;
				}).catch(resp => {
					console.log('请求失败：' + resp);
				});
			},
			onRead2(file) {
				let param = new FormData(); //创建form对象
				param.append('base64Data', file.content); //通过append向form对象添加数据
				param.append('height', '260'); //添加form表单中其他数据
				param.append('width', '260'); //添加form表单中其他数据
				//console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
				axios({
					method: "POST",
					url: global.baseURL + 'base/uploadImgCommon',
					data: param,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((resp) => {
					this.Data.orgIntroduction += "<img src='" + global.resoursePhoto + resp.data + "'>";
				}).catch(resp => {
					console.log('请求失败：' + resp);
				});
			},
			onEditorBlur() { //失去焦点事件
			},
			onEditorFocus() { //获得焦点事件
			},
			onEditorChange(e) { //内容改变事件
			},
			//获取服务类型
			getType() {
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/dictionary/selectList?type=type_zhfy'
				}).then((resp) => {
					var columns = resp.data.list;
					for(var i = 0; i < columns.length; i++) {
						this.columns.push(columns[i].name);
					}
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/select',
					params: {
						"id": this.$route.query.id
					}
				}).then((resp) => {
					this.Data = resp.data.data;
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			ajax() {
				if(!this.checkForm()){
					return false;
				}
				Toast.loading({
					mask: true,
					message: '正在提交...',
					duration: 0
				});
				this.Data.auth_token = this.$cookies.get("auth_token");
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/orgform/OrgUpdate',
					params: this.Data
				}).then((resp) => {
					if(resp.data.status == 1) {
						Toast.success('更新成功');
						setTimeout(() => {
							this.$router.go(0);
						}, 1000);
					} else {
						Toast.fail(resp.data.msg);
					}
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			getOid() { //获取
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/selectAllOrg',
					params: {}
				}).then((resp) => {
					var list = resp.data;
					var array = [];
					var oid = 0;
					for(var i = 0; i < list.length; i++) {
						if(oid != 0 && list[i].id == oid) {
							var a = {
								label: list[i].orgName,
								id: list[i].id,
								children: array
							}
							array = [];
							array.push(a);
						} else {
							array.push({
								label: list[i].orgName,
								id: list[i].id
							});
						}
						oid = list[i].oid;
					}
					this.data = array;
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			//树形点击事件
			handleNodeClick(data) {
				Toast('你选择了 ' + data.label);
				this.oid = data.id;
			},
			//删除文件
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleChange(file, fileList) {
				this.fileList = fileList;
			},
			//取消地区弹出层
			cancel() {
				this.show = false;
			},
			//选择地区
			confirm(e) {
				if(e[1] == null) {
					this.Data.regulatorArea = e[0].name;
					this.show = false;
					this.Data.volunteerCorps = e[0].code;
				} else if(e[2] == null) {
					this.Data.regulatorArea = e[0].name + "-" + e[1].name;
					this.show = false;
					this.Data.volunteerCorps = e[1].code;
				} else {
					this.Data.regulatorArea = e[0].name + "-" + e[1].name + "-" + e[2].name;
					this.show = false;
					this.Data.volunteerCorps = e[2].code;
				}
			},
			//地区弹出层
			select() {
				this.show = true;
			},
			//跳转
			run(p) {
				this.$router.push({
					path: p
				});
			}
		}
	}
</script>

<style>
	#org_edit .el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	
	#org_edit .el-icon-arrow-down {
		font-size: 12px;
	}
	
	#org_edit * {
		font-size: 14px;
	}
	
	#org_edit .van-radio-lable {
		margin-top: 10px;
		min-width: 58px;
		text-align: center;
		font-size: 14px;
		margin-right: 40px;
		margin-left: 4%;
	}
	
	#org_edit .van-radio-group {
		min-height: 44px;
		display: flex;
		height: auto;
	}
	
	#org_edit .van-radio {
		margin-top: 10px;
		flex: 1;
		max-width: 30%;
	}
	
	#org_edit textarea {
		margin: 10px 0px;
	}
	
	#org_edit .el-upload-list__item-name {
		display: none;
	}
	
	#org_edit .el-upload-list__item {
		max-width: 250px;
	}
	
	#org_edit .el-tree-node {
		margin: 10px;
		margin-left: 0px;
	}
	
	#org_edit .upload-demo {
		margin: 10px 0px;
		flex: 1;
	}
	
	#org_edit .van-field__label {
		margin-right: 6px;
	}
</style>